import axios from 'axios';

const API = axios.create({
  baseURL: 'https://api.manik-rhino.com/',
  // baseURL: process.env.baseURL,
  // baseURL: 'http://localhost:5001',
  timeout: 10000, // Set a default timeout (10 seconds)
});

// Request interceptor for adding the token to headers
API.interceptors.request.use(
  (req) => {
    try {
      const data = localStorage.getItem('tokenData');
      const token = data ? JSON.parse(data) : null;

      if (token) {
        req.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error parsing token data:', error);
    }
    
    // Check if the request contains FormData and handle it appropriately
    if (req.data instanceof FormData) {
      // Don't set the Content-Type header because the browser will automatically set it for FormData
      delete req.headers['Content-Type'];
    }
    return req;
  },
  (error) => {
    // Handle errors before they are sent
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors globally
API.interceptors.response.use(
  (response) => {
    // Successful response
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle server errors
      console.error(`API Error [${error.response.status}]: ${error.response.data.message || error.message}`);
    } else if (error.request) {
      // Handle network errors or no response
      console.error('No response from server:', error.message);
    } else {
      // Other unexpected errors
      console.error('Unexpected error:', error.message);
    }

    // Optionally show a user-friendly message
    if (error.response?.status === 401) {
      console.warn('Unauthorized! Redirecting to login...');
      // Redirect to login page or clear token
      localStorage.removeItem('tokenData');
      window.location.href = '/login'; // Adjust to your app's login route
    }

    return Promise.reject(error);
  }
);



// Default export of the API instance
export default API;
